module.exports = __webpack_public_path__ + "static/media/img-about-hero-bg.422d94aa.svg";